import { render, staticRenderFns } from "./light-switch.vue?vue&type=template&id=75908849&"
import script from "./light-switch.js?vue&type=script&lang=js&"
export * from "./light-switch.js?vue&type=script&lang=js&"
import style0 from "./light-switch.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports